
var jwt_token = localStorage.getItem('jwt_token') || '';
var uname = localStorage.getItem('uname') || '';
export default {
  uname: uname,
  share_uname: '',
   //判断是否为生产环境
  // jwt_token: process.env.NODE_ENV == 'development' ? "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.IntcInVuaW9uSWRcIjpcIm9MZ19Ndzl0aVl1VUFOUnB2SWZSVFlHVVNaV0lcIixcInVpZFwiOjgxMjcsXCJsb2dpbl90aW1lXCI6MTU1OTYxNjk3Mn0i.AlqztUcFxoV9m2qv6Nx7vx7hPLAfeoQc3GNUrFz3SQU" : "",
  jwt_token: jwt_token,
  img_url: process.env.NODE_ENV == 'development' ? "http://mu.eguowang.com" : "http://admxwjybackend.csohu.cn",
  yunxin_json: '',
  // 菜单开启开关
  menu_open_status: {
    ifopen_ask: 0, //问答开启
    ifopen_quesiton: 1, //题库开启
  },
  is_iphoneX: false, //判断是否为iphonex
  userbing_phoneStatus: false, //是否需要绑定手机号
  // socket_live: 'wss://kxm.grazy.cn/wss',

  // IM相关
  // 登录账户ID
  userUID: null,
  // 用户名片
  myInfo: {},
  // 好友/黑名单/陌生人名片, 数据结构如：{cid: {attr: ...}, ...}
  userInfos: {},
  // 好友列表
  friendslist: [],
  // 消息列表
  msgs: {}, // 以sessionId作为key
  msgsMap: {}, // 以idClient作为key，诸如消息撤回等的消息查找
  // 会话列表
  sessionlist: [],
  sessionMap: {},
  allunread:0,
  // 当前会话ID（即当前聊天列表，只有单聊群聊采用，可用于判别）
  currSessionId: null,
  currSessionMsgs: [],
  // 系统消息
  sysMsgs: [],
  customSysMsgs: [],
  sysMsgUnread: {
    total: 0
  },
  customSysMsgUnread: 0,
  // 全屏显示的原图
  isFullscreenImgShow: false,
  fullscreenImgSrc: '',
  // 正在加载中
  isLoading: true,
  noMoreHistoryMsgs: false
}



// WEBPACK FOOTER //
// ./src/store/state.js